import { useEffect, useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FiArrowUpRight } from "react-icons/fi";

function PostingCard({ posting }) {

    return (
        <div className="posting-card">
            <img src={posting.thumbnail} alt={posting.title} className="thumbnail" />
            <div className="overlay">
                <div className="badge">Featured</div>
                <div className="content">
                    <div className="contentTitle title ">{posting.title}</div>
                </div>
                <div className="hover-content">
                    <div className="title">{posting.title}</div>
                    <button className="view-button" onClick={() => window.open(posting.linkTo, "_blank")}>View {posting.type} <FiArrowUpRight size={20} /></button>
                </div>
            </div>
        </div>
    );
}

function ImageSlider() {
    const postings = [
        {
            thumbnail: "/assets/images/hero1.jpg",
            title: "Premium Wireless Over-Ear Headphones with Noise Cancellation & Deep Bass",
            type: "Product",
            linkTo: "/productDetails/687c9f9edaf26fc04314a728"
        },
        {
            thumbnail: "/assets/images/hero2.jpg",
            title: "I will create a modern minimalist and luxury logo design",
            type: "Service",
            linkTo: "/postingDetails/687cde047b6a4d5f93a70ac2"
        },
        {
            thumbnail: "/assets/images/hero3.jpg",
            title: "RGB Gaming Mouse with Custom DPI, Programmable Buttons & Ergonomic Grip",
            type: "Product",
            linkTo: "/productDetails/687ce4317b6a4d5f93a71805"
        },
        {
            thumbnail: "/assets/images/hero4.jpg",
            title: "Next-Gen 4K Gaming Console with Dual Wireless Controllers",
            type: "Product",
            linkTo: "/productDetails/687ce36a7b6a4d5f93a716e5"
        },
        {
            thumbnail: "/assets/images/hero5.jpg",
            title: "Wireless Bluetooth Earbuds with Noise Cancellation & 30-Hour Battery Life",
            type: "Product",
            linkTo: "/productDetails/687ce4d07b6a4d5f93a718be"
        },
        {
            thumbnail: "/assets/images/hero6.jpg",
            title: "Gaming Console with Ultra-HD Graphics, Fast Load Times & Immersive Gameplay",
            type: "Product",
            linkTo: "/productDetails/687ce47d7b6a4d5f93a71877"
        },
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isTabVisible, setIsTabVisible] = useState(true);
    const [resetInterval, setResetInterval] = useState(0); // New state to trigger interval reset

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % postings.length);
        setResetInterval((prev) => prev + 1); // Trigger interval reset
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + postings.length) % postings.length);
        setResetInterval((prev) => prev + 1); // Trigger interval reset
    };

    useEffect(() => {
        const handleVisibilityChange = () => {
            setIsTabVisible(!document.hidden);
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        let interval;
        if (isTabVisible) {
            interval = setInterval(() => {
                nextSlide();
            }, 6000);
        }

        return () => clearInterval(interval); // Cleanup on unmount or when dependencies change
    }, [isTabVisible, resetInterval]); // Depend on resetInterval to restart timer

    return (
        <div className="imageSliderDiv">
            <div className="imageSliderContent" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                {postings.map((posting, index) => (
                    <PostingCard key={index} posting={posting} />
                ))}
            </div>
            <div className="arrows">
                <button onClick={prevSlide}><IoIosArrowBack /></button>
                <button onClick={nextSlide}><IoIosArrowForward /></button>
            </div>
        </div>
    );
}

export default ImageSlider;